export default "/assets/images/pug.6622e3058859811a.webm";